// extracted by mini-css-extract-plugin
export default {"wrapper":"src-client-components-ModuleBody-styles-___default__wrapper___mg-rl"};